import{  observer, state, action,Router,Pointer,RouterProps,ComponentView,h,Utils,Preact } from "@websites/website_compiler/Client";
import * as Routes from "../gen/routes"
export interface ActiveDropDown{
    ref;
    callback : Function;
}

export interface UiProps extends RouterProps{
}
export class Ui extends Router<{test:string}>{
    
    // devMode = false;
    routes : typeof Routes.Obj;
    pointer = new Pointer();
    activeDropDowns : ActiveDropDown[] = [];
    @state sidePanelVisible = false;
    lazyLoad = true;

    @state modal = {
        show: false,
        component:null,
        props:null,
        callback:Function,
    };

    constructor(props:UiProps){
        super(props as any);
        console.log("this.serverSide",this.serverSide);
        if(!this.serverSide){

            this.origin = location.origin;
            this.addEventListeners();
            this.goToUrlSync(`${location.pathname || ''}${location.search || ''}`,this.props.pageProps);

        }else{

            this.origin =  "http://localhost:3000";

            if( this.props.page ){
                
                this.startFromRoute(this.props.url,this.props.page,this.props.pageProps)

            }else if( this.props.url ){

                this.goToUrlSync(this.props.url,{});

            }

        }

    }

    @action toggleSidePanel(){
        this.sidePanelVisible = !this.sidePanelVisible;
    }
    @action setSidepanelVisibility(isVisible){
        this.sidePanelVisible = isVisible;
    }
    @action closeModal(callbackArgs,dontCall = false) {
        console.log("closeModal",typeof this.modal.callback);
        
        this.modal.show = false;
        this.modal.component = null;
        this.modal.props = null;
        if(!dontCall){
            this.modal.callback(callbackArgs)

        }
        this.modal.callback = null;
    }

    lazyLoadImages(wait = 1000){
        setTimeout(() => {
            var images = document.getElementsByTagName('img'); 
            var svgImages = document.getElementsByTagName('image');
            console.log("svgImages",svgImages);
    
            for(var i = 0; i < images.length; i++) {
                // console.log("images[i]",images[i].src);
                
                if(images[i].dataset.src){
                    images[i].src = images[i].dataset.src;
                }
            }
            for(var i = 0; i < svgImages.length; i++) {
                // console.log("svg images[i]",i,svgImages[i].dataset,svgImages[i].dataset.href);
                
                if(svgImages[i].dataset.href){
                    svgImages[i].href.baseVal = svgImages[i].dataset.href;
                    // console.log(" svgImages[i].href.baseVal", svgImages[i].href.baseVal, svgImages[i].dataset);
                    
                }
            }
            this.lazyLoad = false;

        }, wait);

    }
    onAboutToNavigate(configNode){
        console.log("onAboutToNavigate",this);
        if(!this.serverSide){
            this.setSidepanelVisibility(false);

        }
        this.closeModal(null,true);
        this.lazyLoad = true;
        return true;
    }
    
    // EVENT LISTENERS
    addEventListeners(){
        super.addEventListeners();
        document.addEventListener('mousedown', this._onMouseDown);
        document.addEventListener('mouseup', this._onMouseUp);
        document.addEventListener("touchstart", this._onTouchStart, false);
    }
    _onMouseDown = (event) =>{
        this.pointer.setDown(event);  
        // console.log("_onMouseDown",event,event.x,event.y);
        // alert(" mouse down");

        if (this.activeDropDowns.length > 0 ) {
            var dropDown = this.activeDropDowns[this.activeDropDowns.length  -1];
            if( !dropDown.ref.current || !dropDown.ref.current.contains(event.target)){
                console.log("CALLING CALLBACK");
                
                dropDown.callback();
                this.activeDropDowns.pop();
                console.log("CALLING CALLBACK DONE");

            }
        }
    }  
    _onTouchStart = (event) =>{
        // this.pointer.setDown(event);  
        console.log("touchstart",event);
        
        var touch = event.changedTouches[0];
        console.log("touch",touch);
        
        // if (this.activeDropDowns.length > 0 ) {
        //     var dropDown = this.activeDropDowns[this.activeDropDowns.length  -1];
        //     if( !dropDown.ref.current || !dropDown.ref.current.contains(event.target)){
        //         dropDown.callback();
        //         this.activeDropDowns.pop();
        //     }
        // }
    }  
    setActiveDropDown(args:ActiveDropDown,ignoreLastMouseDown?:boolean){   
        console.log("setActiveDropDown",args);
        
        if(this.activeDropDowns.length > 0){
            var latestDropDown = this.activeDropDowns[this.activeDropDowns.length -1];
            if(args && latestDropDown.ref.current && latestDropDown.ref.current.contains(args.ref.current)){
                this.addDropDown(args);
                return;
            }else{
                for (let i = 0; i < this.activeDropDowns.length; i++) {
                    this.activeDropDowns[i].callback();
                }
            }
        }
        if(args){
            this.activeDropDowns = [args];
        }else{
            this.activeDropDowns = [];
        } 
    }  
    addDropDown(args:ActiveDropDown){
        console.log("addDropDown",args);
        
        this.activeDropDowns.push(args);
    }
    _onMouseUp = (event) =>{
      this.pointer.setUp(event);  
    }
    callLastDropDown(){
        if(this.activeDropDowns.length > 0){
            var latestDropDown = this.activeDropDowns[this.activeDropDowns.length -1];
            latestDropDown.callback();
            this.activeDropDowns.pop();
        }
    }


}


export class AEComponentViewProps{  
    ui?:Ui;
}
@observer export class AEComponentView<P> extends ComponentView<P & AEComponentViewProps>{
    ui:Ui;
    constructor(props:P & AEComponentViewProps){
        super(props);
        // console.log("AR COMPONENT VIEW",props);
        
        this.ui = this.props.ui;
    }
}

